import React from "react"
import PropTypes from "prop-types"
import {
  Box,
  InfoCircleIcon,
  TextXS,
  TextSM,
  HeadingThree,
  Flex,
  Tooltip,
} from "datastory-shared/ui"
import { Section, PageHeader } from "datastory-shared/sections"

import { Timeline } from "./Timeline"
import { Chart } from "./Chart"

const ElectionTracker = ({ data }) => {
  const upcomingElections = data.filter(d => !d.isPast)

  return (
    <>
      <PageHeader
        data-cy="header"
        title={"The Election Tracker"}
        lead={
          "Keep track of upcoming national elections around the world. Updated regularly."
        }
        sublead={
          <Flex
            display={["none", "flex"]}
            justifyContent="center"
            alignItems="center"
          >
            <TextXS muted>
              This data story is part of our Visualizing Wikipedia project
            </TextXS>
            <Tooltip
              label={
                <Box>
                  <TextSM fontWeight={600} as="h4" mb="xs">
                    Visualizing Wikipedia
                  </TextSM>
                  <TextSM>
                    {
                      "Datastory's editorial team contributes to keeping Wikipedia/Wikidata up to date regarding election dates. We retrieve that data periodically to keep this visualization current."
                    }
                  </TextSM>
                </Box>
              }
              placement="top"
            >
              <span>
                <InfoCircleIcon ml=".3rem" variant="ghost" />
              </span>
            </Tooltip>
          </Flex>
        }
      />
      <Section variant="sm">
        <Box my="lg" data-cy="chart">
          <Chart data={data} />
        </Box>

        <Box>
          <HeadingThree textAlign="center" mt={["sm", "md", "xl"]}>
            Next General Elections
          </HeadingThree>
          <Box mt="lg" mb="xl" data-cy="timeline">
            <Timeline data={upcomingElections} />
          </Box>
        </Box>
      </Section>
    </>
  )
}

ElectionTracker.propTypes = {
  data: PropTypes.array,
}

export default ElectionTracker
